import React, {useEffect, useState, Fragment} from 'react';
import FarmerItem from './../../components/ui/FarmerItem';
import Pagination from '../../components/ui/Pagination';
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import Loader from '../../components/ui/Loader';
import LoadModules from '../../components/ui/LoadModules';
import {getFarmers, getStaticPage} from '../../utils/services';
import DataFilter from '../../components/ui/DataFilter';
import Meta from '../../components/ui/Meta';
import {currentLang, accentsTidy, farmerURL} from '../../utils/functions';
import {isNull, isNil} from 'lodash';
import NotFound from '../static/404';
import { useTranslation } from 'react-i18next';
import SearchState from '../../components/ui/SearchState';

const FarmerList = ({loading, farmers_data, farmers_list_static, page, filter}) => {
	const [data, setData] = useState();
	const [filteredData, setFilteredData] = useState([]);
	const [staticData, setStaticData] = useState();
	const [modules, setModules] = useState(null);
	const [filterType, setFilterType] = useState(null);
	const [activePage, setActivePage] = useState(1);
	const [searchStatus, setSearchStatus] = useState(null);
	const { t } = useTranslation();
	//console.log(page);
	
	useEffect(() => {
		//console.log(farmers_data);
		if (isNil(farmers_data)) {
			getFarmers();
			getStaticPage(t("menu.farmers"), 'farmers_list_static');
		}

		if(farmers_data){
			farmers_data.total = farmers_data.length;
			farmers_data.per_page = 9;
			setData(farmers_data);
			setFilterType(filter);
			if(page && page > 1){
				//i = (page-1)*farmers_data.per_page;
				setActivePage(page);
			}
		}
		
	}, [farmers_data]);

	useEffect(() => {
		if(farmers_list_static !== undefined){
			setStaticData(farmers_list_static);
			if(farmers_list_static.modules && farmers_list_static.modules.module !== null){
				setModules(farmers_list_static.modules);
			}
		}
	}, [farmers_list_static])
	
	useEffect(() => {
		//console.log(filter);
		if(data){
			//console.log(filter);
			setFilterType(filter);
		
			filterFunc({value:filter, pageNumber:page})
		}
	  }, [data, filter, page])


	const filterFunc = ({value, pageNumber, search, searchState}) =>{
		//console.log(data);
		if(searchState == "search_empty"){
			setSearchStatus('only3char');
			setFilteredData([]);
			return false;
		}
		//console.log(search, value, pageNumber);
		if(search && search.length > 0){
			search = search.toLowerCase();
			var fdata = [];
			if(search.length < 2){
				setSearchStatus('3char');
				setFilteredData(fdata);
			}else{
				data.map((item, index)=>{
					if(accentsTidy(item.title).includes(search) || accentsTidy(item.location).includes(search)){
						fdata.push(item);
					}
				});
				if(fdata.length < 1){
					setSearchStatus('noresult');
					setFilteredData(fdata);
				}else{
					fdata.total = 100;
					fdata.per_page = 1000;
					setFilteredData(fdata);
					setSearchStatus(null);
				}
				
			}
		}else{
			setSearchStatus(null);
			if(!pageNumber) pageNumber = 1;
			setActivePage(pageNumber);
			var fdata = [];
			var j = 0; // nice variable name :)
			var i = (pageNumber-1)*data.per_page;
			page = pageNumber;

			var total = 0;
			var id = 0;
			
			//if(!isNull(value))
			if(value != filterType){
				page = 1;
			}

			setFilterType(value);
			data.map((item, index)=>{
				
				if(isNull(value)){
					//total++;
					if(j < data.per_page && id >= i){
						fdata.push(item);
						//i++;
						j++;
					}
					id++;
				}else{

					if(item.animal_types && item.animal_types.includes(value) && item.slug != t("farmers.newfarmerslug")){
						total++;
						if(j < data.per_page && id >= i){
							//console.log(i);
							fdata.push(item);
							//i++;
							j++;
						}
						id++;
					}else{

						if(item.slug == t("farmers.newfarmerslug")){
							total++;
						}
					}
					
				}
				
				
			})
			//console.log(Math.ceil(total/farmers_data.per_page));
			if(value != 'game'){
				//var has_newfarmer_page = false;
				//console.log(Math.ceil(total/farmers_data.per_page) , pageNumber, has_newfarmer_page)
				data.map((item, index)=>{
					if(!isNull(value) && Math.ceil(total/farmers_data.per_page) == pageNumber && item.slug == t("farmers.newfarmerslug")){
						if(item.animal_types && item.animal_types.includes(filterType)){
							fdata.push(item);
							total++; // for new farmers
						}
					}
				})
			}
			//console.log(fdata);
			//filteredData.total = filteredData.length;
			
			if(isNull(value)){
				fdata.total = data.total;
			}else{
				fdata.total = total;
			}
			
			//console.log("total: "+fdata.total);
			fdata.per_page = farmers_data.per_page;
			setFilteredData(fdata);
		}
	}
	if (loading) {
		return <Loader />
	} else {

		return (
			<Fragment>
			<LoadModules modules={modules} type="top" />
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="back__row mt-30 mb-30">
							 <a href={"/"+currentLang()+"/"}> <span className="icon-back"></span> </a>
						</div>
					</div>
				</div>

				

				<div className="row">
					{staticData &&
						<Fragment>
						<Meta
							title={staticData.seo_title ? staticData.seo_title : staticData.title}
							description={staticData.seo_description ? staticData.seo_description : staticData.body}
						/>
						{staticData.body &&
							<div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2 mb-10">
								<h1 className="heading--h1">{staticData.title}</h1>
								<p> {parse(staticData.body)}</p>
							</div>
						}
						</Fragment>
					}
				</div>

				<DataFilter type="farmers" filterType={filterType} filterFunc={filterFunc} data={data} />
				
				<div className="row">
					{filteredData && filteredData.map((item, index)=>{
						return (
							<div key={index} className="col-xs-12 col-md-6 col-lg-4">
								<FarmerItem key={index} data={item} type={filterType} animal={t(filterType)} />
							</div>
						)
					})}
				</div>
				<SearchState status={searchStatus} />
				{data && filteredData && activePage && 
					<Pagination url={farmerURL('')} data={filteredData} curPage={activePage} loadData={filterFunc} type="client" filterType={filterType} />
				}

			
			
		</div>
		<LoadModules modules={modules} type="bottom" />
		</Fragment>



		)
	}
}

export default flatstore.connect(['loading', 'farmers_data', 'farmers_list_static'])(FarmerList);